

































import Vue from 'vue';
import { CTA } from '@/@types/member';
export default Vue.extend({
  name: 'ButtonGroup',
  props: {
    heading: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array as () => CTA[],
      required: true,
    },
  },
  computed: {
    computedHeading(): string {
      return this.heading
        ? this.heading
        : this.$options.filters.t('global_i-want-to-ellipsis');
    },
  },
});
